import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import SuperAdminArchivedUserManagement from 'views/super-admin/user-management/archived-super-admins';

// page routing
const SuperAdminDashboard = Loadable(lazy(() => import('views/super-admin/dashboard/index')));
const SuperAdminUserManagement = Loadable(lazy(() => import('views/super-admin/user-management/index')));
const CreateSuperAdminPage = Loadable(lazy(() => import('views/super-admin/user-management/create-user')));
const EditSuperAdminPage = Loadable(lazy(() => import('views/super-admin/user-management/edit-user')));
const OrganizationScreen = Loadable(lazy(() => import('views/super-admin/organizations/OrganizationScreen')));
const ArchivedOrganizationsScreen = Loadable(lazy(() => import('views/super-admin/organizations/ArchivedOrganizationsScreen')));
const SuperAdminReportScreen = Loadable(lazy(() => import('views/super-admin/reports/SuperAdminReportScreen')));

// shared pages
const UpdatePasswordPage = Loadable(lazy(() => import('views/shared/update-password')));
const ConfigureTwoFactorSettingsPage = Loadable(lazy(() => import('views/shared/configure-2fa-settings/ConfigureTwoFactorSettings')));

// ==============================|| SUPER ADMIN ROUTING ||============================== //

const SuperAdminRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <SuperAdminDashboard />
        },
        {
            path: '/dashboard',
            element: <SuperAdminDashboard />
        },
        {
            path: '/organizations/create',
            element: <OrganizationScreen />
        },
        {
            path: '/organizations/edit',
            element: <OrganizationScreen />
        },
        {
            path: '/super-admin/archived-organizations',
            element: <ArchivedOrganizationsScreen />
        },
        {
            path: '/super-admin/user-management',
            element: <SuperAdminUserManagement />
        },
        {
            path: '/super-admin/archived',
            element: <SuperAdminArchivedUserManagement />
        },
        {
            path: '/super-admin/users/create',
            element: <CreateSuperAdminPage />
        },
        {
            path: '/super-admin/users/:id/edit',
            element: <EditSuperAdminPage />
        },
        {
            path: '/report/super-admin',
            element: <SuperAdminReportScreen />,
        },
        {
            path: '/user/update-password',
            element: <UpdatePasswordPage />
        },
        {
            path: '/2fa-settings',
            element: <ConfigureTwoFactorSettingsPage />
        }
    ]
};

export default SuperAdminRoutes;

